import React, { Component } from 'react';
import logo from './logo.png';
import 'bootstrap/dist/css/bootstrap.css';
import LogoutIcon from '@mui/icons-material/Logout';
import PersonIcon from '@mui/icons-material/Person';
class Header extends Component {
    logout = () => {
        localStorage.removeItem('loginToken');
        document.location.reload();
    }
    
    render() {
        return (

            
            <div>
                <header>
                    <nav className="navbar ">
                        <div className="navbar-header">
                            <h1 className="logo">
                                <a href="https://billing.destinationventure.com/" className="navbar-brand" title="DESTINATION VENTURE LLP - Tourism Representation | Sales &amp; Marketing  Brand Visibility | Market Research" rel="home">
                                    <img  src={logo} height="80" alt="DESTINATION VENTURE LLP" />	</a>
                            </h1>
                        </div>
                        <div>
                            303 Vardhman Taru Plaza CU Block Pitampura New Delhi -110034 <br></br> +91-9599395089,+91-9871163568 <br></br> operations@destinationventure.com,marketing@destinationventure.com <br></br> GSTIN:07AAOFD5054D1ZJ
                        </div>
                        <ul className="nav navbar-nav navbar-right mr-5">
                            <li><PersonIcon />{localStorage.getItem('user')}</li>
                            <br></br>
                            <li><button onClick={this.logout}><LogoutIcon/> Logout</button></li>
                        </ul>
                        
                </nav>
                </header>
            </div>
        );
    }
}
export default Header;